<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="home-popup-add-form-modal-label">
                {{ $root.text('Add homepage pop-up', null, true) }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="alert alert-success" role="alert" :style="'display: ' + (updated ? 'block' : 'none')">
                <div class="row">
                    <div class="col-1" style="max-width: 30px"><i class="far fa-check"></i></div>
                    <div class="col" v-html="updated_message"></div>
                </div>
            </div>
            <div class="form-column" :style="'display: ' + (updated ? 'none' : 'block')">
                <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

                <form v-on:submit.prevent="onSubmit()">
                    <div class="form-group">
                        <label for="popup-title">{{ $root.text('Title', null, true) }}</label>
                        <input
                            v-model="popup.title"
                            type="text"
                            id="popup-title"
                            class="form-control"
                            :readonly="updating"
                            maxlength="200"
                        >
                    </div>
                    <div class="form-group">
                        <label id="popup-body_text-label" class="mandatory-label">
                            {{ $root.text('Content', null, true) }} *
                        </label>
                        <editor
                            v-if="!updated"
                            v-model="popup.body_text"
                            :init="tiny_editor_init"
                            :disabled="updating"
                        ></editor>
                    </div>
                    <div class="form-group">
                        <label>{{ $root.text('Link', null, true) }}</label>
                        <div v-if="!isLinked()">
                            <button
                                type="button"
                                class="btn btn-secondary"
                                :disabled="updating"
                                @click.prevent="chooseLink()"
                            >
                                <i class="far fa-link mr-1"></i> {{ $root.text('Choose link', null, true) }}
                            </button>
                        </div>
                        <div v-else class="form-control" style="height: auto">
                            <div v-if="((popup.link_type == 'folder') || (popup.link_type == 'subfolder'))">
                                <span v-if="popup.link_type == 'folder'">
                                    {{ $root.text(
                                        'Link to {folder}:',
                                        {
                                            folder: $root.text(
                                                $root.contents.folder_title,
                                                null,
                                                false,
                                                'folder_title'
                                            )
                                        },
                                        true
                                    ) }}
                                </span>
                                <span v-else>
                                    {{ $root.text(
                                        'Link to {subfolder}:',
                                        {
                                            subfolder: $root.text(
                                                $root.contents.subfolder_title,
                                                null,
                                                false,
                                                'subfolder_title'
                                            )
                                        },
                                        true
                                    ) }}
                                </span>
                                {{ linkedToFolder() }}
                                <a
                                    v-if="!updating"
                                    href="#"
                                    v-b-tooltip.hover
                                    :title="$root.text('Remove link', null, true)"
                                    @click.prevent="removeLink()"
                                    style="line-height: 1; position: relative; top: 1px"
                                >
                                    <i class="far fa-times-circle font-size-16 ml-1"></i>
                                </a>
                            </div>
                            <div v-if="(popup.link_type == 'asset')">
                                {{ $root.text(
                                    'Link to {resource} No. {x}',
                                    {
                                        resource: $root.text(
                                            $root.contents.asset_title,
                                            null,
                                            false,
                                            'asset_title'
                                        ),
                                        x: popup.link_value
                                    },
                                    true
                                ) }}
                                <a
                                    v-if="!updating"
                                    href="#"
                                    v-b-tooltip.hover
                                    :title="$root.text('Remove link', null, true)"
                                    @click.prevent="removeLink()"
                                    style="line-height: 1; position: relative; top: 1px"
                                >
                                    <i class="far fa-times-circle font-size-16 ml-1"></i>
                                </a>
                            </div>
                            <div v-if="(popup.link_type == 'latest_assets')">
                                {{ $root.text(
                                    'Link to latest {x} uploads / edited {resources}',
                                    {
                                        x: popup.link_value,
                                        resources: $root.text(
                                            $root.contents.asset_title + 's',
                                            null,
                                            false,
                                            'assets_title'
                                        )
                                    },
                                    true
                                ) }}
                                <a
                                    v-if="!updating"
                                    href="#"
                                    v-b-tooltip.hover
                                    :title="$root.text('Remove link', null, true)"
                                    @click.prevent="removeLink()"
                                    style="line-height: 1; position: relative; top: 1px"
                                >
                                    <i class="far fa-times-circle font-size-16 ml-1"></i>
                                </a>
                            </div>
                            <div v-if="(popup.link_type == 'keywords')">
                                <span
                                    v-html="$root.text('Link to {keywords}',
                                        { keywords: linkedToKeywords() }, true)"
                                ></span>
                                <a
                                    v-if="!updating"
                                    href="#"
                                    v-b-tooltip.hover
                                    :title="$root.text('Remove link', null, true)"
                                    @click.prevent="removeLink()"
                                    style="line-height: 1; position: relative; top: 1px"
                                >
                                    <i class="far fa-times-circle font-size-16 ml-1"></i>
                                </a>
                            </div>
                            <div v-if="(popup.link_type == 'url')">
                                {{ $root.text('Link to:', null, true) }} {{ popup.link_value }}
                                <a
                                    v-if="!updating"
                                    href="#"
                                    v-b-tooltip.hover
                                    :title="$root.text('Remove link', null, true)"
                                    @click.prevent="removeLink()"
                                    style="line-height: 1; position: relative; top: 1px"
                                >
                                    <i class="far fa-times-circle font-size-16 ml-1"></i>
                                </a>
                            </div>
                            <div v-if="(popup.link_type == 'collection')">
                                {{ $root.text('Link to collection: {collection}',
                                    { collection: linkedToCollection() }, true) }}
                                <a
                                    v-if="!updating"
                                    href="#"
                                    v-b-tooltip.hover
                                    :title="$root.text('Remove link', null, true)"
                                    @click.prevent="removeLink()"
                                    style="line-height: 1; position: relative; top: 1px"
                                >
                                    <i class="far fa-times-circle font-size-16 ml-1"></i>
                                </a>
                            </div>
                            <div v-if="(popup.link_type == 'collections')">
                                {{ $root.text('Link to multiple collections', null, true) }}
                                <a
                                    v-if="!updating"
                                    href="#"
                                    v-b-tooltip.hover
                                    :title="$root.text('Remove link', null, true)"
                                    @click.prevent="removeLink()"
                                    style="line-height: 1; position: relative; top: 1px"
                                >
                                    <i class="far fa-times-circle font-size-16 ml-1"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div v-if="keywords_warning" class="alert alert-warning" role="alert">
                        {{ $root.text('Content added after today that has any keyword selected here will '
                            + 'add to the results.', null, true) }}
                        {{  $root.text('If you do not want this to happen, create a collection and link '
                            + 'the pop-up to that collection.', null, true) }}
                    </div>

                    <div v-if="isLinked()" class="form-group">
                        <label>{{ $root.text('Link button', null, true) }}</label>
                        <div class="form-control" style="height: auto">
                            <div class="row">
                                <div class="col-sm-7 col-12">
                                    <div class="form-group">
                                        <label
                                            for="popup-button_text"
                                            id="popup-button_text-label"
                                            class="mandatory-label"
                                        >
                                            {{ $root.text('Button text', null, true) }} *
                                        </label>
                                        <input
                                            v-model="popup.button_text"
                                            type="text"
                                            id="popup-button_text"
                                            class="form-control"
                                            :readonly="updating"
                                            v-on:keyup="$root.unHighlightErrors('popup-button_text')"
                                            v-on:change="$root.unHighlightErrors('popup-button_text')"
                                        >
                                    </div>
                                </div>
                                <div class="col-sm-5 col-12">
                                    <div class="form-group">
                                        <label>{{ $root.text('Button position', null, true) }}</label>
                                        <div class="btn-group btn-block">
                                            <button
                                                type="button"
                                                class="btn btn-light dropdown-toggle"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                                :disabled="updating"
                                                :style="'text-align: left; box-shadow: 0 0.05rem'
                                                    + ' 0.75rem rgba(18, 38, 63, 0.03) !important'"
                                            >
                                                {{ optionText(getButtonPositionOptions(),
                                                    popup.button_position) }}
                                                <i
                                                    class="fas fa-chevron-down"
                                                    style="position: absolute; top: 10px; right: 10px"
                                                ></i>
                                            </button>
                                            <div class="dropdown-menu">
                                                <a
                                                    v-for="option in getButtonPositionOptions()"
                                                    class="dropdown-item"
                                                    :key="option.key"
                                                    href="#"
                                                    @click.prevent="updateField('button_position', option.key)"
                                                >
                                                    {{ option.value }}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="(user_groups.length > 0)" class="form-group">
                        <label for="popup-user_groups">
                            {{ $root.text('Visible to these user groups', null, true) }}
                        </label>
                        <searchable-option-list
                            :key="'popup-user-groups' + ($root.current_language || 0)"
                            v-model="popup.user_groups"
                            :value="popup.user_groups"
                            :multiple="true"
                            :options="getUserGroupOptions()"
                            field_id="popup-user_groups"
                            field_class="form-control pb-2"
                            :readonly="updating"
                            :placeholder="$root.text('You can choose more than one', null, true)"
                            v-on:sol-dropdown="userGroupsDropdown"
                        ></searchable-option-list>
                    </div>
                </form>
            </div>
        </div>
        <div v-if="($root.hasPermission('manage_homepage_popups') && !updated)" class="modal-footer">
            <span v-if="!updating">
                <button :key="'save-button'" type="button" class="btn btn-primary" @click="onSubmit()">
                    <i class="far fa-save mr-1"></i> {{ $root.text('Save', null, true) }}
                </button>
            </span>
            <span v-else>
                <button :key="'saving-button'" type="button" class="btn btn-primary">
                    <i class="fal fa-spinner-third fa-spin mr-1"></i>
                    <span style="opacity: 0.5">{{ $root.text('Save', null, true) }}</span>
                </button>
            </span>
        </div>
    </div>
</template>

<script>
    import 'tinymce'
    import Editor from '@tinymce/tinymce-vue';
    import 'tinymce/icons/default/icons.min.js';
    import 'tinymce/themes/silver/theme.min.js';
    import 'tinymce/models/dom/model.min.js';
    import 'tinymce/skins/ui/oxide/skin.js';
    import 'tinymce/plugins/advlist';
    import 'tinymce/plugins/autolink';
    import 'tinymce/plugins/lists';
    import 'tinymce/plugins/link';
    import 'tinymce/plugins/image';
    import 'tinymce/plugins/charmap';
    import 'tinymce/plugins/preview';
    import 'tinymce/plugins/anchor';
    import 'tinymce/plugins/searchreplace';
    import 'tinymce/plugins/visualblocks';
    //import 'tinymce/plugins/code';
    import 'tinymce/plugins/fullscreen';
    import 'tinymce/plugins/insertdatetime';
    //import 'tinymce/plugins/media';
    import 'tinymce/plugins/table';
    import 'tinymce/plugins/help';
    import 'tinymce/plugins/wordcount';
    import 'tinymce/skins/content/default/content.js';
    export default {
        components: {
            'editor': Editor
        },
        data () {
            return {
                errors: false,
                updating: false,
                updated: false,
                updated_message: '',
                popup: {},
                tiny_editor_init: {
                    license_key: 'gpl',
                    height: 500,
                    promotion: false,
                    elementpath: false,
                    branding: false,
                    resize: true,
                    plugins: [
                        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                        'anchor', 'searchreplace', 'visualblocks', 'fullscreen',
                        'insertdatetime', 'table', 'help', 'wordcount'
                    ],
                    menubar: 'edit view insert format tools table help',
                    font_family_formats: 'Poppins=poppins;',
                    toolbar: 'undo redo | blocks | ' +
                        'bold italic backcolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat | help',
                    /* enable title field in the Image dialog */
                    image_title: true,
                    /* enable automatic uploads of images represented by blob or data URIs */
                    /*automatic_uploads: true,
                    file_picker_types: 'image',
                    file_picker_callback: (cb, value, meta) => {
                        const input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');

                        input.addEventListener('change', (e) => {
                            const file = e.target.files[0];

                            const reader = new FileReader();
                            reader.addEventListener('load', () => {
                                const id = 'blobid' + (new Date()).getTime();
                                const blobCache =  tinymce.activeEditor.editorUpload.blobCache;
                                const base64 = reader.result.split(',')[1];
                                const blobInfo = blobCache.create(id, file, base64);
                                blobCache.add(blobInfo);

                                cb(blobInfo.blobUri(), { title: file.name });
                            });
                            reader.readAsDataURL(file);
                        });

                        input.click();
                    },*/
                    content_style: this.$root.tiny_mce_content_styles,
                    font_size_formats: '8pt 10pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 30pt 36pt 42pt 48pt'
                },
                user_groups: [],
                keywords_warning: false
            }
        },
        mounted () {
            this.getUserGroups();

            // Prevent Bootstrap dialog from blocking focusin
            $(document).on('focusin', function(e) {
                if (
                    $(e.target).closest(".tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root").length
                ) {
                    e.stopImmediatePropagation();
                }
            });
        },
        watch: {
            //
        },
        methods: {
            resetForm: function () {
                if (!this.$root.hasPermission('manage_homepage_popups')) {
                    this.errors = this.$root.text('Sorry, you do not have access to this function.', null, true);

                    return false;
                }
                this.updating = true;
                this.popup = {
                    id: 'new',
                    user_groups: [this.$root.edit_homepage_user_group],
                    button_position: 'left'
                };
                this.errors = false;
                this.updating = false;
                this.updated = false;
                this.updated_message = '';
                if (this.popup.user_groups.length == 0) {
                    this.popup.user_groups = [-1];
                }
                this.keywords_warning = false;
                $('.mandatory-label').removeClass('text-danger');
                $('.mandatory-field').removeClass('field-error');
            },
            onSubmit: function () {
                this.errors = false;
                this.updating = true;
                $('.mandatory-label').removeClass('text-danger');
                $('.mandatory-field').removeClass('field-error');

                /**
                 * Send request to API.
                 */
                let data = {};
                for (const [key, value] of Object.entries(this.popup)) {
                    if (key == 'user_groups') {
                        data[key] = this.getUserGroupsValue(value);
                    } else {
                        data[key] = value;
                    }
                }
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/homepage-popup';
                var vm = this;

                axios({
                    method: 'post',
                    url: url,
                    data: data,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.updated = 'Success';
                    if (response.data.message) {
                        vm.updated = true;
                        vm.updated_message = response.data.message;
                        vm.$parent.getPopups();
                    }

                    setTimeout(function () {
                        $('#home-popup-add-form-modal').modal('hide');
                    }, 2000);
                })
                .catch(function (error) {
                    vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                    if (error.response) {
                        if (error.response.status == 401) {
                            // Missing/lost API token - close modal and logout user.
                            $('#home-popup-add-form-modal').modal('hide');
                            vm.$root.doLogout();
                        }
                        if (error.response.data.error) {
                            if (typeof error.response.data.error === 'string') {
                                vm.errors = error.response.data.error;
                            } else if (typeof error.response.data.error === 'object') {
                                vm.errors = '';
                                for (const [key, value] of Object.entries(error.response.data.error)) {
                                    let errorHtml = value.join('<br>') + '<br>';
                                    vm.errors += errorHtml.replace('body text', 'content');
                                    $('#popup-' + key + '-label').addClass('text-danger');
                                    $('#popup-' + key).addClass('field-error');
                                }
                            }
                        }
                    }
                })
                .finally(() =>
                    vm.updating = false
                );
            },
            optionText: function (options, key) {
                let itemIndex = -1;
                options.forEach((item, index) => {
                    if (item.key == key) {
                        itemIndex = index;
                    }
                });
                if (itemIndex > -1) {
                    return options[itemIndex].value;
                }

                return 'Select';
            },
            chooseLink: function () {
                this.keywords_warning = false;
                const appComponent = this.$root.findComponent(this.$root, 'main-app');
                const component = this.$root.findComponent(appComponent, 'select-item');
                component.reset(
                    ['folder', 'asset', 'latest_assets', 'keywords', 'url', 'collections'],
                    this.$root.text('Choose link', null, true),
                    this,
                    'popup-link'
                );
                $('#select-item-modal').modal('show');
                $('.modal-backdrop').css({ 'z-index': '1060', 'opacity': '0.25' });
            },
            removeLink: function () {
                this.updating = true;
                this.keywords_warning = false;
                this.popup.link_type = null;
                this.popup.link_value = null;
                this.popup.button_text = null;
                var vm = this;
                setTimeout(function () {
                    vm.updating = false;
                }, 200);
            },
            updateField: function (field, value) {
                this.popup[field] = value;
            },
            getUserGroups: function () {
                /**
                 * Send request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/user-groups/!private';
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.user_groups = response.data.user_groups;
                })
                .catch(function (error) {
                    // Do anything?
                });
            },
            getUserGroupOptions: function () {
                let options = [{
                    id: -1,
                    name: this.$root.text('All users', null, true)
                }];
                if (this.user_groups) {
                    this.user_groups.forEach((item) => {
                        options.push({
                            id: item.id,
                            name: item.name
                        });
                    });
                }

                return options;
            },
            getUserGroupsValue: function (userGroups) {
                if (userGroups) {
                    if (userGroups.indexOf(-1) < 0) {
                        return userGroups;
                    }
                }

                return [];
            },
            userGroupsDropdown: function (event) {
                if (event.show) {
                    $('.form-column').css('padding-bottom', '200px');
                    $('.form-column').animate({ scrollTop: '+=300' }, 700);

                    return null
                }
                $('.form-column').css('padding-bottom', '0');
            },
            selectedItem: function (field, itemType, value) {
                this.updating = true;
                this.popup.link_type = itemType;
                this.popup.link_value = value;

                /*let scrollTo = $('.header_text-fg').outerHeight();
                scrollTo += $('.header_text_colour-fg').outerHeight();
                scrollTo += $('.header_colour-fg').outerHeight();
                scrollTo += $('.body_image-fg').outerHeight();
                scrollTo += $('.body_colour-fg').outerHeight();
                scrollTo += $('.body_text_colour-fg').outerHeight();
                scrollTo += $('.body_text-fg').outerHeight();
                scrollTo += $('.link-fg').outerHeight();
                scrollTo += 200;

                $('.form-column').animate({ scrollTop: scrollTo }, 700);*/

                if (itemType == 'keywords') {
                    this.keywords_warning = true;
                }

                var vm = this;
                setTimeout(function () {
                    vm.updating = false;
                }, 200);
            },
            linkedToFolder: function () {
                const linkValueParts = this.popup.link_value.split('::');

                return linkValueParts[linkValueParts.length - 1];
            },
            linkedToKeywords: function () {
                const keywords = this.popup.link_value.split(',');
                let keywordsText = [];
                keywords.forEach((keyword) => {
                    keywordsText.push('&quot;' + keyword.replace(/"/g, '&quot;').replace(/'/g, '&apos;') + '&quot;');
                });
                let text = 'keyword';
                if (keywords.length > 1) {
                    text += 's';
                }
                text += ': ' + keywordsText.join(', ');

                return text;
            },
            linkedToCollection: function () {
                const linkValueParts = this.popup.link_value.split('::');

                return linkValueParts[linkValueParts.length - 1];
            },
            isLinked: function () {
                if (!this.popup.link_value) {
                    return false;
                }

                return true;
            },
            getButtonPositionOptions: function () {
                const options = [
                    {
                        key: 'left',
                        value: this.$root.text('Left', null, true)
                    },
                    {
                        key: 'center',
                        value: this.$root.text('Center', null, true)
                    },
                    {
                        key: 'right',
                        value: this.$root.text('Right', null, true)
                    }
                ];

                return options;
            }
        }
    }
</script>
